import arrayTools from '@/technical/arrayTools/arrayTools'

import mainCommonDataLoader from '../components/mainCommonDataLoader'
import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import serverData from '@/store/serverData'

export default function (theComponent, cb) {
  var sailsIO = theComponent.$sails
  var appSettings = theComponent.appSettings

  // var serverUrl = appSettings.server.host

  // сначала подготавливаем листенера
  sailsIO.socket.on('connect', function onConnect () {
    console.log('>>>>>>> sailsWebsocket connected to server ' + sailsIO.sails.url + ' at ' + new Date(Date.now()))

    // ///////////////////////////////////////////////////////////////////////////////////////////////

    sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'fileEntities'}, function (data, jwRes) {
      if (jwRes.statusCode !== 200) console.error('>>>>>>>> Suscribing to Model`s Notifier of fileEntities return ERROR: ', data)
      /* else console.log('>>>>>>>> Suscribed to Model`s Notifier of places.') */
    })

    sailsIO.socket.on('fileEntity', function (data) {
      // console.log('>>>>>>>> On places. Received:', data)
      handleDataWithValValue('fileEntities', 'fileEntity', theComponent.appSettings.server.fileEntityResource, data)
    })

    // ///////////////////////////////////////////////////////////////////////////////////////////////

    sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'places'}, function (data, jwRes) {
      if (jwRes.statusCode !== 200) console.error('>>>>>>>> Suscribing to Model`s Notifier of places return ERROR: ', data)
      /* else console.log('>>>>>>>> Suscribed to Model`s Notifier of places.') */
    })

    sailsIO.socket.on('place', function (data) {
      // console.log('>>>>>>>> On places. Received:', data)
      handleDataWithValValue('places', 'place', theComponent.appSettings.server.placeResource, data, 'images')
    })

    // ///////////////////////////////////////////////////////////////////////////////////////////////

    sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'events'}, function (data, jwRes) {
      if (jwRes.statusCode !== 200) console.error('>>>>>>>> Suscribing to Model`s Notifier of events return ERROR: ', data)
      /* else console.log('>>>>>>>> Suscribed to Model`s Notifier of events.') */
    })

    sailsIO.socket.on('event', function (data) {
      // console.log('>>>>>>>> On events. Received:', data)
      handleDataWithValValue('events', 'event', theComponent.appSettings.server.eventResource, data, 'body')
    })

    // ///////////////////////////////////////////////////////////////////////////////////////////////

    sailsIO.socket.post('/api/' + appSettings.server.modelsNotifierSubscription, {roomName: 'eventsMembers'}, function (data, jwRes) {
      if (jwRes.statusCode !== 200) console.error('>>>>>>>> Suscribing to Model`s Notifier of eventsMembers return ERROR: ', data)
      /* else console.log('>>>>>>>> Suscribed to Model`s Notifier of eventsMembers.') */
    })

    sailsIO.socket.on('eventMember', function (data) {
      // console.log('>>>>>>>> On eventMember. Received:', data)
      handleDataWithValValue('eventsMembers', 'eventMember', theComponent.appSettings.server.eventMemberResource, data, 'body')
    })

    // ///////////////////////////////////////////////////////////////////////////////////////////////

    // console.log('>>>>>>> mainCommonDataLoader starts')
    // вся перезагрузка commonData должна производится при любом ре-коннекте сокета чтобы не потерять данные которые обновлялись пока не было связи
    // serverData.debugMsg = 'Сокет подконнектился УСПЕШНО'
    theComponent.commonDataIsLoadedSet(false)
    mainCommonDataLoader({all: true}, function (error) {
      if (error) {
        console.log('>>>>>>> mainCommonDataLoader finished with ERROR: ' + error)
        serverErrorHandling(error, theComponent)
        cb(error)
      } else {
        // console.log('>>>>>>> mainCommonDataLoader finished')
        theComponent.commonDataIsLoadedSet(true)
        cb()
      }
    })

    // ///////////////////////////////////////////////////////////////////////////////////////////////
  })

  // преобразуем http://localhost:1777/api/ в http://localhost:1777 чтобы sails socket достучался
  // sailsIO.sails.url = serverUrl.substr(0, serverUrl.substr(0, serverUrl.lastIndexOf('/')).lastIndexOf('/')) + '/'
  // и коннектимся вот такой строкой. но ща это и автоматом работает
  // // var mySocket = sailsIO.sails.connect()

  // ///////////////////////////////////////////////////////////////////////////////////////////////
  /*
  function handleData (dataName, resourceUrl, data) {
    data.initiator = 'realtimeServerDataManager'
    switch (data.method) {
      case 'create':
        let item = restResource(resourceUrl)
        item.val = Object.assign({}, data.record)
        serverData[dataName].push(item)
        if (serverData[dataName + 'Map'] != null) serverData[dataName + 'Map'][item.val.id] = item
        console.log('realtimeServerDataManager.emitting: ' + dataName + 'Changed')
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'update':
        let itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id)
        if (itemNum != null) {
          serverData[dataName][itemNum].val = Object.assign(serverData[dataName][itemNum].val, data.record) // не меняя объект перетираем значения
          // здесь serverData[dataName + 'Map'] не надо проверять и менять тк выше мы не меняем объект restResource в serverData а только val у него
        } else { // делаем как будто новый create
          let item = restResource(resourceUrl)
          item.val = Object.assign({}, data.record)
          serverData[dataName].push(item)                                                       fileEntities
          if (serverData[dataName + 'Map'] != null) serverData[dataName + 'Map'][item.val.id] = item
        }
        console.log('realtimeServerDataManager.emitting: ' + dataName + 'Changed')
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'destroy':
        itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id)
        if (itemNum != null) {
          var itemId = serverData[dataName][itemNum].val.id
          serverData[dataName].splice(itemNum, 1)
          if (serverData[dataName + 'Map'] != null) delete serverData[dataName + 'Map'][itemId]
        }
        serverData[dataName + 'OnDestroy'](data.record, function (err) {  // =financeOperationsOnDestroy like
          if (err) return console.log('ERRRRROR123')
          console.log('realtimeServerDataManager.emitting: ' + dataName + 'Changed')
          serverData.eventsBus.$emit(dataName + 'Changed', data) // !!!!! Changed??? не Destroyed или что-то типа того?
          return
        })
        break
    }
  }
  */
  // ///////////////////////////////////////////////////////////////////////////////////////////////

  // !!!!!!!!! Через сокет при UPDATE данные в val.value приходят как string. Поэтому их надо JSON.parse !!! В отличие от простого html get request, где все приходит как JSON !!!
  // !!!! тут надо переделать логику потому что не у всех объектов в serverData есть массив, но може быть только ассоциативный массив Map
  function handleDataWithValValue (dataName, recordTypeName, resourceUrl, data, valField) {
    data.initiator = 'realtimeServerDataManager'
    data.type = recordTypeName
    switch (data.method) {
      case 'create':
        let item = restResource(resourceUrl)
        item.val = Object.assign({}, data.record)
        if (valField != null) item.val[valField] = Object.assign({}, data.record[valField])
        if (serverData[dataName] != null) serverData[dataName].push(item)
        if (serverData[dataName + 'Map'] != null) serverData[dataName + 'Map'][item.val.id] = item
        if (dataName === 'events') serverData.eventsRecalcEventMembering(serverData.eventsMap[item.val.id]) // для новых event создаем event.membering
        if (dataName === 'eventsMembers') serverData.eventsRecalcEventMembering(serverData.eventsMap[item.val.refToEvent])
        if (dataName === 'eventsMembers') serverData.usersLoadEventMemberUnknownUser(data, function (err) { if (err) console.log(err) })
        console.log('realtimeServerDataManager.emitting: ' + dataName + 'Changed')
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'update':
        let itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id) // !!!!!!!! давно в serverData данные c Map есть !!!!
        if ((itemNum != null) || ((serverData[dataName + 'Map'] != null) && (serverData[dataName + 'Map'][data.record.id] != null))) {
          if (serverData[dataName] != null) {
            serverData[dataName][itemNum].val = Object.assign(serverData[dataName][itemNum].val, data.record) // не меняя объект перетираем значения
            if (valField != null) serverData[dataName][itemNum].val[valField] = JSON.parse(data.record[valField]) // не меняя объект перетираем значения
            // здесь serverData[dataName + 'Map'] не надо проверять и менять тк выше мы не меняем объект restResource в serverData а только val у него
          }
          if ((serverData[dataName] == null) && ((serverData[dataName + 'Map'] != null) && (serverData[dataName + 'Map'][data.record.id]))) {
            serverData[dataName + 'Map'][data.record.id].val = Object.assign(serverData[dataName + 'Map'][data.record.id].val, data.record) // не меняя объект перетираем значения
            if (valField != null) serverData[dataName + 'Map'][data.record.id].val[valField] = JSON.parse(data.record[valField]) // не меняя объект перетираем значения
          }
          if (dataName === 'eventsMembers') serverData.eventsRecalcEventMembering(serverData.eventsMap[data.record.refToEvent])
        } else { // делаем как будто новый create
          let item = restResource(resourceUrl)
          item.val = Object.assign({}, data.record)
          if (valField != null) item.val[valField] = Object.assign({}, JSON.parse(data.record[valField]))
          if (serverData[dataName] != null) serverData[dataName].push(item)
          if (serverData[dataName + 'Map'] != null) serverData[dataName + 'Map'][item.val.id] = item
          if (dataName === 'events') serverData.eventsRecalcEventMembering(serverData.eventsMap[item.val.id]) // для новых event создаем event.membering
          if (dataName === 'eventsMembers') serverData.eventsRecalcEventMembering(serverData.eventsMap[item.val.refToEvent])
          if (dataName === 'eventsMembers') serverData.usersLoadEventMemberUnknownUser(data, function (err) { if (err) console.log(err) })
        }
        console.log('realtimeServerDataManager.emitting: ' + dataName + 'Changed')
        serverData.eventsBus.$emit(dataName + 'Changed', data)
        break
      case 'destroy':
        itemNum = arrayTools.findItemNum(serverData[dataName], data.record.id)
        if (itemNum != null) {
          var itemId = serverData[dataName][itemNum].val.id
          serverData[dataName].splice(itemNum, 1)
          if (serverData[dataName + 'Map'] != null) delete serverData[dataName + 'Map'][itemId]
        }
        serverData[dataName + 'OnDestroy'](data.record, function (err) {  // =financeOperationsOnDestroy like
          if (err) return console.log('ERRRRROR123')
          console.log('realtimeServerDataManager.emitting: ' + dataName + 'Changed')
          serverData.eventsBus.$emit(dataName + 'Changed', data) // !!!!! Changed??? не Destroyed или что-то типа того?
          return
        })
        break
    }
  }

  // ///////////////////////////////////////////////////////////////////////////////////////////////

  return // cb() // теперь cb() вызывается когда все CommonData через mainCommonDataLoader загружены. в первую очередь чтобы отобразить меню, ибо сначала его надо получить с сервера
}



// WEBPACK FOOTER //
// ./src/technical/realtimeServerDataManager.js